"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var evaluate = function (condition) {
    if (typeof condition === 'boolean') {
        return condition;
    }
    if (typeof condition === 'function') {
        return condition();
    }
    console.error('Invalid condition provided to RenderIf', { condition: condition });
    return false;
};
var RenderIf = function (_a) {
    var children = _a.children, condition = _a.condition;
    if (evaluate(condition)) {
        return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: children }, void 0);
    }
    return null;
};
exports.default = RenderIf;
